import { createContext, useContext } from 'react';
import { PACKAGE_THEMES } from '../utils/packageTheme';

const StudentThemeContext = createContext(PACKAGE_THEMES.default);

export const StudentThemeProvider = StudentThemeContext.Provider;
export function useStudentTheme() {
    return useContext(StudentThemeContext);
}
